import styled, { withTheme } from "styled-components";
import { MAX_PAGES } from "./constants";
import React from "react";

const StyledPagination = styled.ul`
  span.page-link {
    color: ${(props) => props.theme?.gray};
    text-decoration: none;
  }
  .page-item.active > span.page-link {
    background-color: ${(props) => props.theme?.gray};
    color: #fff;
  }
  @media (max-width: 575px) {
    justify-content: start !important;
  }

  li.disabled {
    pointer-events: none;
  }
`;

const StyledNumber = styled.span`
  padding: ${(props) =>
    props.$small ? "0.1rem 0.4rem !important" : "0.5rem 0.75rem"};
  margin-right: ${(props) => (props.$small ? "5px" : "0px")};
  background-color: transparent;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  display: inline;
  margin: 0;
  padding: 0;
  color: ${(props) => props.theme?.yellowGreen};
  &:hover {
    text-decoration: underline;
    color: ${(props) => props.theme?.violetEggplant};
  }
`;

const TablePagination = (props) => {
  const { specificKey, specificParams, total, getData, small, isRtl, loading } =
    props;

  const getTotalPages = () => {
    return Math.ceil(total / specificParams.limit);
  };

  const changePageHandler = (pageNumber) => {
    if (pageNumber >= 0 && pageNumber <= total - 1) {
      let params = {
        ...specificParams,
        page: pageNumber,
      };

      if (specificKey) {
        getData(specificKey, params);
      } else {
        getData(params);
      }
    }
  };

  const getPages = () => {
    const pages = [];

    const totalPages = getTotalPages();

    let paginationInitialValue =
      specificParams.page + MAX_PAGES >= totalPages - 1
        ? totalPages - (MAX_PAGES + 1)
        : specificParams.page;
    if (paginationInitialValue < 0) {
      paginationInitialValue = 0;
    }

    for (let i = paginationInitialValue; i < totalPages; i++) {
      if (i < specificParams.page) {
        if (specificParams.page - i > MAX_PAGES) {
          continue;
        }
        pages.push(
          <li
            data-testid={`previous-page-${i}`}
            key={"li_key_" + i}
            className={`page-item${loading ? " disabled" : ""}`}
            onClick={() => changePageHandler(i)}
          >
            <StyledNumber
              $small={small}
              data-action={`open-page-${i + 1}`}
              className="page-link"
            >
              {i + 1}
            </StyledNumber>
          </li>
        );
      } else if (i === specificParams.page) {
        pages.push(
          <li
            data-testid="active-page"
            data-type="item"
            key={"li_key_" + i}
            className={`page-item active${loading ? " disabled" : ""}`}
            onClick={() => changePageHandler(i)}
          >
            <StyledNumber
              $small={small}
              data-action={`open-page-${i + 1}`}
              className="page-link"
            >
              {i + 1}
            </StyledNumber>
          </li>
        );
      } else if (i > specificParams.page) {
        if (i - specificParams.page > MAX_PAGES) {
          continue;
        }
        pages.push(
          <li
            data-testid={`next-page-${i}`}
            key={"li_key_" + i}
            className={`page-item${loading ? " disabled" : ""}`}
            onClick={() => changePageHandler(i)}
          >
            <StyledNumber
              $small={small}
              data-action={`open-page-${i + 1}`}
              className="page-link"
            >
              {i + 1}
            </StyledNumber>
          </li>
        );
      }
    }
    return pages;
  };

  return (
    <>
      {getTotalPages() > 1 && (
        <StyledPagination
          data-testid="CustomPagination"
          id="pagination-list"
          className="pagination justify-content-end"
        >
          {specificParams.page > 0 && (
            <li
              data-testid="previous-arrow"
              data-type="item"
              key="li_key_previous"
              id="prev"
              className={`page-item${loading ? " disabled" : ""}`}
              onClick={() => changePageHandler(specificParams.page - 1)}
            >
              <StyledNumber
                $small={small}
                className="link-button page-link"
                aria-label="Previous"
              >
                <i
                  className={`fas ${
                    isRtl ? "fa-angle-right" : "fa-angle-left"
                  }`}
                  aria-hidden="true"
                />
              </StyledNumber>
            </li>
          )}

          {getPages()}
          {specificParams.page + MAX_PAGES < getTotalPages() - 1 && (
            <li
              data-testid="next-arrow"
              data-type="item"
              key="li_key_next"
              id="next"
              className={`page-item${loading ? " disabled" : ""}`}
              onClick={() => changePageHandler(specificParams.page + 1)}
            >
              <StyledNumber
                $small={small}
                className="link-button page-link"
                aria-label="Next"
              >
                <i
                  className={`fas ${
                    isRtl ? "fa-angle-left" : "fa-angle-right"
                  }`}
                  aria-hidden="true"
                />
              </StyledNumber>
            </li>
          )}
        </StyledPagination>
      )}
    </>
  );
};

export default withTheme(TablePagination);
